// Parallel to GatedSpaceOverlay by design - the two scope wrappers share UI via
// GatedFeedOverlay but keep their scope-specific access checks separate so a
// future divergence is a one-file change.
import type { FC, ReactNode } from 'react';

import type { GateScope } from '~/constants/community';

import { useCommunityAccess } from '../_hooks/useCommunityAccess';
import { useCommunityMembership } from '../_hooks/useCommunityMembership';
import { GatedFeedOverlay } from './GatedFeedOverlay';

interface GatedCommunityOverlayProps {
  scope: GateScope;
  children: ReactNode;
  /** Public surfaces such as member profiles still let guests read the content. */
  allowGuests?: boolean;
}

export const GatedCommunityOverlay: FC<GatedCommunityOverlayProps> = ({ scope, children, allowGuests = false }) => {
  const { isCommunityAccessible } = useCommunityAccess();
  const { isMember } = useCommunityMembership();

  if (allowGuests && !isMember) return children;
  if (isMember && isCommunityAccessible) return children;

  return <GatedFeedOverlay scope={scope}>{children}</GatedFeedOverlay>;
};
